import 'what-input';
import './polyfill';
import 'intersection-observer';
import hashScroll from './hashScroll';
import changeMetaViewport from './changeMetaViewport';
import toggleHeader from './toggleHeader';
import toggleMenu from './toggleMenu';
import setupEyecatch from './setupEyecatch';
import observeIntersection from './observeIntersection';
import setupSlider from './setupSlider';
import slider from './slider';

hashScroll();
changeMetaViewport();

document.addEventListener('DOMContentLoaded', () => {
  toggleHeader();
  toggleMenu();
  setupEyecatch();
  setupSlider();
  slider();

  if (window.CSS) {
    observeIntersection();
  } else {
    setTimeout(() => {
      [].slice.call(document.querySelectorAll('.js-observer')).forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.dataset.loaded = 'true';
      });
    }, 100);
  }
});
